import { styled } from '@linaria/react';
import { fonts, layout, primitives, semantic, size, space } from '../../theme/tokens';

export { Badge, IconWrapper } from '../../styles/nav.styles';

export const Rail = styled.nav`
  display: none;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    width: ${layout.sideNavWidth};
    height: 100vh;
    padding: ${space['space-2000']} ${space['space-400']} ${space['space-800']};
    border-right: ${size.stroke['stroke-default']} solid ${semantic.border.default};
    background: ${semantic.bg.canvas};
    position: sticky;
    top: 0;
    align-self: flex-start;
    z-index: 102;
  }
`;

export const TopItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space['space-300']};
`;

export const BottomItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space['space-300']};
  position: sticky;
  bottom: ${space['space-800']};
`;

export const IconContainer = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${space['space-200']} ${space['space-500']};
  border-radius: ${size.radius['radius-full']};
  transition: background 0.15s ease;
`;

export const NavItem = styled.button<{ $active?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space['space-100']};
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${semantic.text.primary};

  & ${IconContainer} {
    background: ${({ $active }) => ($active ? semantic.bg.surfaceDefault : 'transparent')};
  }

  &:hover ${IconContainer} {
    background: ${semantic.bg.surfaceDefault};
  }
`;

export const NavLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
`;
